import { ref as n } from "vue";
/* empty css         */
/* empty css         */
/* empty css         */
import "./index282.js";
import "@template/types";
/* empty css         */
let l = 0;
const c = () => (l += 1, `modal-${l}`), e = n([]), m = (o) => {
  e.value.includes(o) || e.value.push(o);
}, v = (o) => {
  const t = e.value.indexOf(o);
  t !== -1 && e.value.splice(t, 1);
}, f = (o) => e.value[e.value.length - 1] === o, x = (o) => e.value.indexOf(o);
export {
  c as generateModalId,
  x as getModalStackIndex,
  f as isTopModal,
  v as popModal,
  m as pushModal
};
